import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from 'react-table';

import { formatNumberAsCurrency } from '@work4all/utils';

import { Alignment } from '../../types';

export const NUMBER_PARAMS = {
  cellParams: {
    maximumFractionDigits: 2,
  },
  alignment: 'right' as Alignment,
};

export const CURRENCY_PARAMS = {
  cellParams: {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  },
  alignment: 'right' as Alignment,
};

export interface ExtendedNumberCell {
  column: {
    cellParams?: {
      minimumFractionDigits?: number;
      maximumFractionDigits?: number;
    };
  };
}

export type INumberCellProps = {
  value: string | number;
  column?: {
    id: string;
  };
  row?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    original: any;
  };
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  className?: string;
  onEdit?: () => void;
  style?: React.CSSProperties;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cell: Cell<any, any> & ExtendedNumberCell;
};

export const NumberCell = (props: INumberCellProps) => {
  let { minimumFractionDigits = 0, maximumFractionDigits = 0 } = props;
  const { value, className = '', style } = props;

  const { i18n } = useTranslation();

  if (props.cell.column.cellParams) {
    const params = props.cell.column.cellParams;
    minimumFractionDigits = params.minimumFractionDigits || 0;
    maximumFractionDigits = params.maximumFractionDigits || 0;
  }

  const displayValue = useMemo(() => {
    if ((typeof value === 'string' && value === '0') || value === 0) {
      return '';
    } else {
      return formatNumberAsCurrency(
        typeof value === 'string' ? parseInt(value, 10) : value,
        {
          locale: i18n.language,
          minimum: minimumFractionDigits,
          maximum: maximumFractionDigits,
        }
      );
    }
  }, [i18n.language, maximumFractionDigits, minimumFractionDigits, value]);

  return (
    <div
      style={{ textAlign: 'right', ...style }}
      className={className}
      onClick={props.onEdit}
    >
      {displayValue || ''}
    </div>
  );
};
